import { queryKey } from 'Shared/const/queryKey';
import type { GetPointTrendOkDto } from 'viewup-api';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';
import type { ViewingMoneyQueryKey } from './queries';

interface PointTrendProps {
  query: {
    monthValue?: number;
    type: 'day' | 'year';
    yearValue: number;
  };
}

export const useGetTrend = (
  { query }: PointTrendProps,
  params?: QueryParam<
    GetPointTrendOkDto,
    unknown,
    GetPointTrendOkDto,
    ViewingMoneyQueryKey['trend']['queryKey']
  >,
) => {
  const queryResult = useSDQuery<
    GetPointTrendOkDto,
    unknown,
    GetPointTrendOkDto,
    ViewingMoneyQueryKey['trend']['queryKey']
  >({
    ...params?.options,
    ...queryKey.viewingMoney.trend(query),
  });

  return queryResult;
};
